import React from 'react';
import { useNotification } from '../contexts/NotificationContext';
import Notification from './Notification';

const NotificationContainer = () => {
  const { notifications, removeNotification } = useNotification();

  // Agregar estilos de animación si no existen.
  // El hook va ANTES de cualquier early return: las reglas de hooks exigen que se
  // llame en el mismo orden en todos los renders (react-hooks/rules-of-hooks).
  React.useEffect(() => {
    const styleId = 'notification-animations';
    if (!document.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = `
        @keyframes slideIn {
          from {
            transform: translateX(100%);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
        @keyframes slideOut {
          from {
            transform: translateX(0);
            opacity: 1;
          }
          to {
            transform: translateX(100%);
            opacity: 0;
          }
        }
      `;
      document.head.appendChild(style);
    }
  }, []);

  if (notifications.length === 0) {
    return null;
  }

  const containerStyle = {
    position: 'fixed',
    top: '20px',
    right: '20px',
    zIndex: 9999,
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    maxWidth: '500px',
    pointerEvents: 'none',
  };

  return (
    <div style={containerStyle}>
      {notifications.map((notification) => (
        <div
          key={notification.id}
          style={{ pointerEvents: 'auto' }}
        >
          <Notification
            notification={notification}
            onClose={removeNotification}
          />
        </div>
      ))}
    </div>
  );
};

export default NotificationContainer;

